export interface TotalActiveVehicule {
  userId?: string;
}

export interface ListAllVehicule {
  userId?: string;
  groupId?: string;
  companyId?: string;
}

export enum VehiculeOwnerType {
  GROUP = 'GROUP',
  COMPANY = 'COMPANY',
}

export const MINIMUM_CAR_REGISTRATION_YEAR = 1885;
